// Keep navigation labels/IDs in this tab so Cart can link back to the same store.
// This is UI context only; it is never included in cart API requests.
export const readShoppingNavigation = (key) => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(key));
    return saved && typeof saved === "object" && !Array.isArray(saved) ? saved : {};
  } catch {
    return {};
  }
};

export const rememberShoppingNavigation = (key, context) => {
  try {
    const saved = readShoppingNavigation(key);
    const segments = { ...saved.segments };
    const stores = { ...saved.stores };
    if (context.segmentId && context.segmentName) {
      segments[context.segmentId] = context.segmentName;
    }
    if (context.businessSegmentId) {
      const previous = stores[context.businessSegmentId] || {};
      // An empty field during loading must not erase an already known label/ID.
      const values = Object.fromEntries(Object.entries(context).filter(([, value]) => value !== ""));
      delete stores[context.businessSegmentId];
      stores[context.businessSegmentId] = { ...previous, ...values };
    }
    sessionStorage.setItem(key, JSON.stringify({
      segments,
      stores: Object.fromEntries(Object.entries(stores).slice(-20)),
    }));
  } catch {
    // Breadcrumb links still work from route/server data when storage is blocked.
  }
};

export const getNavigationValue = (source, keys) => {
  for (const key of keys) {
    const value = source?.[key];
    if ((typeof value === "string" || typeof value === "number") && String(value).trim()) return String(value).trim();
  }
  return "";
};

export const getNavigationIdFromSlug = (slug) => String(slug || "").match(/-(\d+)$/)?.[1] || "";

export const getNavigationLabelFromSlug = (slug) => {
  let value = String(slug || "");
  try { value = decodeURIComponent(value); } catch { /* Use the original malformed slug. */ }
  return value.replace(/-\d+$/, "").replace(/[-_]+/g, " ").trim()
    .replace(/\b[a-z]/g, (letter) => letter.toUpperCase());
};

export const getNavigationSlug = (name, id) => {
  const slug = String(name || "store").toLowerCase().replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") || "store";
  return `${slug}-${id}`;
};
